// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3F8oH","large":"styles_large__NgLvo"};